import { List, ListItem, ListItemIcon, ListItemText, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import LanguageContext from "context/LanguageContext";
import ReviewContext from "context/ReviewContext";
import { GEOSERVICE_NAME } from "descriptions";
import { GeosrviceIcon } from "icons/GeoserviceIcon";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { StepCard } from "./StepCard";
import { CreateGeoServiceTransition, QrSettingsFormFieldType } from "state/ReviewState";

const useStyles = makeStyles()((theme: Theme) => ({
	wrapper: {
		[theme.breakpoints.up("xs")]: {
			maxWidth: theme.spacing(60),
		},
	},
	item: {
		boxShadow: "0px 2px 8px #E0E3E9",
		borderRadius: theme.spacing(1),
		marginBottom: theme.spacing(3),
		width: theme.spacing(40),
		display: "flex",
		justifyContent: "center",
		gap: theme.spacing(2.5),
	},
	icon: {
		minWidth: "unset",
	},
	text: {
		flex: "unset",
	},
}));

interface IProps {
	hash: string;
}

export const GeoserviceLikeStep = observer(({ hash }: IProps) => {
	const { classes } = useStyles();
	const { getTranslate } = useContext(LanguageContext);
	const { setStep, location, fetchCreateGeoTransition, additionalFields } =
		useContext(ReviewContext);

	const geoserviceTransitionSubmit = (type: string) => {
		const data: CreateGeoServiceTransition = {
			hash,
			session_id: localStorage.getItem(window.location.pathname) || "",
			geo_service_type: type,
		};
		fetchCreateGeoTransition(data);
	};

	const geoserviceSettings = additionalFields.find(
		({ type }) => type === QrSettingsFormFieldType.Geoservices,
	)?.value;

	const options = Array.isArray(geoserviceSettings)
		? geoserviceSettings.filter(item => Object.keys(location?.urls || {}).includes(item))
		: Object.keys(location?.urls || {});

	return (
		<StepCard
			title="reviewPage.geoserviceLikeStep.title"
			subTitle="reviewPage.geoserviceLikeStep.subTitle"
			onCancel={() => setStep(4)}
			cancelTitle="reviewPage.geoserviceLikeStep.cancel"
			className={classes.wrapper}
		>
			<List>
				{options.map(item => (
					<ListItem
						key={item}
						className={classes.item}
						button
						onClick={() => {
							geoserviceTransitionSubmit(item);
							setStep(4);
							window.open(location.urls[item]);
						}}
					>
						<ListItemIcon className={classes.icon}>
							<GeosrviceIcon type={item} />
						</ListItemIcon>
						<ListItemText
							data-lang="reviewPage.geoserviceLikeStep.leaveReview"
							primary={getTranslate("reviewPage.geoserviceLikeStep.leaveReview", {
								geoservice: GEOSERVICE_NAME[item],
							})}
							className={classes.text}
							primaryTypographyProps={{ variant: "h4" }}
						/>
					</ListItem>
				))}
			</List>
		</StepCard>
	);
});
